import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { GenericEngineListQuery } from '@rossum/api-client/genericEngines';
import { api } from '../../../lib/apiClient';
import { resolveNextPageParam } from '../../../lib/resolveNextPageParam';
import { genericEngineKeys } from '../keys';

export const useInfiniteGenericEngines = (query: GenericEngineListQuery) =>
  useInfiniteQuery({
    queryKey: genericEngineKeys.list(query),
    queryFn: ({ pageParam = 1 }) =>
      api.request(
        endpoints.genericEngines.list({
          ...query,
          page: pageParam,
        })
      ),
    getNextPageParam: resolveNextPageParam,
  });
